import { SessionStorage } from "@unico-people/shared/utils/storage";

export class DateValidator {
  static brazilianDate(control) {
    if (control.value === null || control.value === '') {
      return null;
    }

    const brazilianDatePattern = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}/;
    if (!control.value.match(brazilianDatePattern)) {
      return { date: true };
    }

    return null;
  }

  static pastDate(control) {
    if (control.value === null || control.value === '') {
      return null;
    }

    const splDate = control.value.split('/');
    const limitDate = new Date(Date.UTC(splDate[2], splDate[1] - 1, splDate[0]));
    const now = new Date();

    const today = new Date(now.getTime() - (now.getTime() % (24 * 60 * 60 * 1000)) + now.getTimezoneOffset() * 60 * 1000);
    const convertedDate = new Date(limitDate.getTime() + limitDate.getTimezoneOffset() * 60000);

    if (convertedDate > today) {
      return { pastDate: true };
    }
    return null;
  }

  static futureDate(control) {
    if (control.value === null || control.value === '') {
      return null;
    }

    const splDate = control.value.split('/');
    const limitDate = new Date(Date.UTC(splDate[2], splDate[1] - 1, splDate[0]));
    const now = new Date();

    const today = new Date(now.getTime() - (now.getTime() % (24 * 60 * 60 * 1000)) + now.getTimezoneOffset() * 60 * 1000);
    const convertedDate = new Date(limitDate.getTime() + limitDate.getTimezoneOffset() * 60000);

    if (convertedDate < today) {
      return { futureDate: true };
    }
    return null;
  }

  static dueDate(control) {
    if (control.value === null || control.value === '') {
      return null;
    }
    const splDate = control.value.split('/');
    const dueDate = new Date(splDate[2], splDate[1] - 1, splDate[0]);
    const limitToday = new Date(new Date().setDate(new Date().getDate() - 30));
    if (dueDate < limitToday) {
      return { dueDate: true };
    }

    return null;
  }

  static birthDate(control) {
    const birthDate = SessionStorage.getItem('birthDate');
    if (control.value === null || control.value === '') {
      return null;
    }
    if (birthDate === control.value) {
      return { birthDate: true };
    }
    if (control.value < birthDate) {
      return { birthDate: true };
    }
    return null;
  }
}
